import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../store/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../api/client/axios';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { isString } from 'lodash';

export const mutateOrganization = async ({ payload, isEdit }) => {
  if (isEdit) {
    const { data } = await apiClient.put('/organizations/' + payload.stripe_customer_id, payload);
    return data;
  } else {
    const { data } = await apiClient.post('/organizations', payload);
    return data;
  }
};

export const useMutateOrganizationHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: mutateOrganization,
    onSuccess: (data, variables) => {
      dispatch(showSnackbar({ message: 'Organization saved successfully.' }));
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message) ? error.message : JSON.stringify(error.message),
            severity: 'error',
          }),
        );
      }
    },
  });

  const onSubmit = async (data, isEdit) => {
    mutation.mutate({ payload: data, isEdit });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
